var map = {
	"./cn.json": "f0f4",
	"./en-MN.json": "0ca3",
	"./en.json": "e088",
	"./es-EC.json": "e2cd",
	"./es.json": "d90a",
	"./fr.json": "2394",
	"./it.json": "06b7",
	"./mn.json": "6f30",
	"./pt-AO.json": "fe47",
	"./pt.json": "6a7b",
	"./zh.json": "8066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15a4";